import API from 'services/api';
import { UserFilterPayloadType } from 'core/constants/filter';
import { ISelectFilterResponse } from 'core/models/filter';
import { FilterModel, ObjModel } from 'core/models';
import SieraResponse from 'core/models/siera-response';

export default class FilterService extends API {
    static baseURL: string = process.env.REACT_APP_DATA_BASE_URL || '';

    constructor() {
      super(FilterService.baseURL, true, true);
    }

    async GetGroups(params:ObjModel.Obj): Promise<Array<FilterModel.ISelectFilterResponse>> {
      return this.responsifyGeneric<Array<FilterModel.ISelectFilterResponse>>(
        await this.instance.get('groups/get-groups', { params }),
      );
    }

    async GetUserFilter(data: IUserOptionsFetchPayload, params:ObjModel.Obj): Promise<FilterModel.IUserFilterOptionResponse> {
      return this.responsifyGeneric<FilterModel.IUserFilterOptionResponse>(
        await this.instance.post('users/get-users', data, { params }),
      );
    }

    async GetLSQDropdownValues(params: ObjModel.Obj, data: ObjModel.Obj): Promise<SieraResponse<ISelectFilterResponse[]>> {
      return this.genericResponseWrapper<ISelectFilterResponse[]>(
        await this.instance.post('filters/get-dropdown-values', data, { params }),
      );
    }

    async GetCustomDefinedDropdownValues(filterKey: string): Promise<Array<ISelectFilterResponse>> {
      return this.responsifyGeneric<Array<ISelectFilterResponse>>(
        await this.instance.get(`filters/get-custom-defined-filter-values?key=${filterKey}`),
      );
    }

    async GetLOSDropdownValues(params: ObjModel.Obj, data: ObjModel.Obj): Promise<FilterModel.IDropdownValuesResponse> {
      return this.responsifyGeneric<FilterModel.IDropdownValuesResponse>(
        await this.instance.post('filters/get-los-dropdown-values', data, { params }),
      );
    }
}

export interface IUserOptionsFetchPayload {
  Type: string,
  Users?: Array<number>,
  Groups?: Array<any>,
  UserIDs: Array<number>,
  InclusionType: UserFilterPayloadType,
  Page: FilterModel.IPage,
  Search: string,
  AdditionalFilters: ObjModel.ObjGeneric<any>
  FetchAllSubordinates: boolean,
  Status?: string,
  FetchAllUsers: boolean,
  UserDrilldownActive: boolean,
}
